import { ReactKit } from '@team/react';
import { Entry as Root } from './entry';
import { Badge } from './components/badge';

export const ImageBase = ReactKit.createCompoundComponent(Root, { Badge });

ImageBase.displayName = 'ImageBase';
ImageBase.Badge.displayName = 'ImageBaseBadge';
